import { navLinks, categories } from "@/mocks/comicData";

export default function Footer() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-background-800 text-background-100">
      <div className="section-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex cursor-pointer items-center gap-2.5"
              aria-label="漫阅指南首页"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-line text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">漫阅指南</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              精选正版国漫、日漫、韩漫、美漫阅读平台，提供高清、更新及时、离线可读的实用推荐与追更攻略，帮你轻松找对看漫画的地方。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="text-base font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    onClick={() => go(link.href)}
                    className="cursor-pointer text-sm text-background-100/80 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-base font-semibold text-background-50">漫画分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <button
                    type="button"
                    onClick={() => go("#category")}
                    className="cursor-pointer text-sm text-background-100/80 transition-colors hover:text-primary-300"
                  >
                    {c.name}漫画（{c.en}）
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 border-t border-background-100/15 pt-6 text-sm text-background-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 漫阅指南 · 坚持正版，理性追更</p>
          <p className="flex items-center gap-3">
            <span>联系邮箱：hello@manyueguide.com</span>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex cursor-pointer items-center gap-1.5 rounded-full bg-background-100/10 px-3.5 py-1.5 text-background-50 ring-1 ring-background-100/20 transition-colors hover:bg-background-100/20"
            >
              <i className="ri-arrow-up-line"></i>
              返回顶部
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
}